import axios from 'axios';
import { change } from 'redux-form';
import { browserHistory } from 'react-router';
import { toFromDates, convertUtcDate, newDate} from '../components/Common/cleanDates';
import moment from 'moment';

import {
  REQUEST_RECEIVES,
  FETCH_RECEIVES_SUCCESS,
  FETCH_RECEIVES_FAILURE,
  SELECT_RECEIVE,
  RESET_CURRENT_RECEIVE,
  REQUEST_CREATING_RECEIVE,
  CREATE_RECEIVE_SUCCESS,
  CREATE_RECEIVE_FAILURE,
  RESET_CREATE_RECEIVE,
  REQUEST_EDITING_RECEIVE,
  EDIT_RECEIVE_SUCCESS,
  EDIT_RECEIVE_FAILURE,
  REQUEST_RECEIVE_DETAIL,
  FETCH_RECEIVE_DETAIL_SUCCESS,
  FETCH_RECEIVE_DETAIL_FAILURE,
  COMPLETE_PURCHASE_ORDER,
  COMPLETE_PURCHASE_ORDER_SUCCESS,
  COMPLETE_PURCHASE_ORDER_FAILURE,
  FETCH_RECEIVE_HISTORY,
  FETCH_RECEIVE_HISTORY_SUCCESS,
  FETCH_RECEIVE_HISTORY_FAILURE,
  SELECT_RECEIVE_HISTORY,
  RESET_CURRENT_RECEIVE_HISTORY,
  FETCH_RECEIVE_HISTORY_DETAIL,
  FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS,
  FETCH_RECEIVE_HISTORY_DETAIL_FAILURE,
  FETCH_ALL_RECEIVE_HISTORY_DETAIL,
  FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS,
  FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE,
  FETCH_RECEIVE_HISTORY_DETAIL_RECORD,
  FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS,
  FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE,
  REQUEST_EDITING_RECEIVE_HISTORY,
  EDIT_RECEIVE_HISTORY_SUCCESS,
  EDIT_RECEIVE_HISTORY_FAILURE,
  RESET_EDIT_RECEIVE_HISTORY,
  DELETE_RECEIVE,
  DELETE_RECEIVE_FINISHED,
  RESET_DELETE_STATUS,
  ATTACH_FILES,
  ATTACH_FILES_SUCCESS,
  ATTACH_FILES_FAILURE,
  FETCH_ATTACHED_FILES,
  FETCH_ATTACHED_FILES_SUCCESS,
  FETCH_ATTACHED_FILES_FAILURE,
  DELETE_ATTACHED_FILES,
  DELETE_ATTACHED_FILES_SUCCESS,
  DELETE_ATTACHED_FILES_FAILURE,
  RESET_ATTACHED_FILES,
  SET_RECEIVE_SELECTED_ROWS,
  SET_RECEIVE_PAGINATION_FILTER,
  SET_RECEIVE_SCROLL_TOP_POSITION_INDEX,
  REQUEST_SYNC_QB_PDF,
  FETCH_SYNC_QB_PDF_SUCCESS,
  FETCH_SYNC_QB_PDF_FAILURE,
} from './type';

import {
  RECEIVE_URL,
  PURCHASE_ORDERS_URL,
  PURCHASE_ORDER_COMPLETE_URL,
  UPLOAD_URL,
  WAREHOUSES_URL,
  LOGICAL_LOCATION_URL
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI, isOCM, ROOT_URL, isHO, isJRC, isOLG, isSH, isAP, isLAP, isAPD, isCCW } from './root_url';

export function fetchReceives() {
    return (dispatch, getState) => {
      const state = getState();
      const warehouse = state.header.selectedWarehouse;
      const company = state.header.selectedCompany;
      if (!warehouse || !warehouse.value) return;
        dispatch(requestReceives());
        return axios.get(`${RECEIVE_URL}?warehouse_id=${warehouse.value}&Company_id=${company.value}`,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchReceivesSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchReceivesFailure(err));
              }
            });
    }
}

export function requestReceives() {
    return {
        type: REQUEST_RECEIVES,
    };
}

export function fetchReceivesSuccess(receives) {
    return {
        type: FETCH_RECEIVES_SUCCESS,
        payload: receives
    };
}

export function fetchReceivesFailure(error) {
    return {
        type: FETCH_RECEIVES_FAILURE,
        payload: error
    };
}

export function selectReceive(receive) {
    return {
        type: SELECT_RECEIVE,
        payload: receive
    };
}

export function resetCurrentReceive() {
    return {
        type: RESET_CURRENT_RECEIVE
    }
}


// Actions to deal with the promise of posting function.

export function createReceive(
  PostingDate,
  InvoiceDate,
  HandlingCost,
  MiscCost,
  ShippingCost,
  PriceAdjustment,
  ShareCost,
  PONum,
  Note,
  Warehouse_id,
  VendorPicklistNum,
  vendor_id,
  ReceivingPrice,
  InvoiceFinalPrice,
  Warehouse_Receive_Line,
  {
    InvoiceNum,
    PackingNum,
    container_num,
    cso_num,
  },
  completeReceive,
  // SyncAp,
  success,
  LocalShipCost = 0,
  StorageCost = 0,
  CustomCost = 0,
  OtherCost = 0,
  OverseaShipCost = 0,
) {
  // let FinalPrice = (parseFloat(TotalPrice) || 0) + (parseFloat(HandlingCost) || 0) + (parseFloat(MiscCost) || 0) + (parseFloat(ShippingCost) || 0);
  Warehouse_Receive_Line.map(
      product => {
          product['StorageRate'] = product.StorageRate || 0;
          if (product.Product_id){
            product.Product_id = product.Product_id.Product_id || product.Product_id;
          }
          if(product['subWeights']) {
            product['Weights'] = [];
            product.subWeights.map(w => {
              product['Weights'].push(parseFloat(w.Weight))
            })
          }
          if(!product.Remark) {
            product.Remark = "";
          }
          if (product['package_date']) {

            if(isCCW) {
              product.package_date = moment(product['package_date']).startOf('day').format();
            } else {
              product.package_date = moment(product['package_date']).toISOString();
            }
          }
      }
  )

  if (vendor_id && vendor_id.value) {
    vendor_id = vendor_id.value;
  }
  let Vendor_id_id = vendor_id;
  let data = {
    PostingDate,
    InvoiceDate,
    HandlingCost,
    MiscCost,
    ShippingCost,
    PriceAdjustment,
    ShareCost,
    PONum,
    Note,
    Warehouse_id,
    VendorPicklistNum,
    vendor_id,
    Vendor_id_id,
    // TotalPrice,
    // FinalPrice,
    ReceivingPrice,
    InvoiceNum,
    PackingNum,
    container_num,
    InvoiceFinalPrice,
    Warehouse_Receive_Line,
    cso_num,
    // SyncAp,
}
if(isGGI) {
  data.LocalShipCost = Number(LocalShipCost || 0);
  data.StorageCost =  Number(StorageCost || 0);
  data.CustomCost = Number(CustomCost || 0);
  data.OtherCost =  Number(OtherCost || 0);
  data.OverseaShipCost =  Number(OverseaShipCost || 0);
}

  InvoiceFinalPrice = parseFloat(InvoiceFinalPrice);
        return dispatch => {
      if (Warehouse_Receive_Line.length > 0 || (isHO || isJRC)) {
        dispatch({ type: REQUEST_CREATING_RECEIVE });
        axios.post(`${WAREHOUSES_URL}receive_pellet_location/history/${PONum}`,
            data,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              // alert('Success!')
              if(/*response.status == 200 || */completeReceive == true){
                let url = PURCHASE_ORDERS_URL + PONum + '/complete/';
                if(isOLG) {
                  url = url + `?PostingDate=${convertUtcDate(newDate(PostingDate))}`;
                }
                axios.get(url,
                  {
                    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                  }
                )
                .then(res => {
                  success && success()
                  dispatch(createReceiveSuccess(response));
                }, err => {
                  if (err.status === 500 || err.status === 404) {
                    err.data = DEFAULT_ERROR;
                  }
                  dispatch(createReceiveFailure(err));
                });
              } else {
                success && success();
                dispatch(createReceiveSuccess(response));
                // browserHistory.push('/inventories/receive/');
              }
            }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                  document.getElementById('tokenInvalid').style.display = 'flex'
                } else {
                  dispatch(createReceiveFailure(err));
                }
            });
        } else if (Warehouse_Receive_Line.length === 0) {
          if (/*response.status == 200 || */completeReceive === true) {
            let url = PURCHASE_ORDERS_URL + PONum + '/complete/';
            if(isOLG) {
                url = url + `?PostingDate=${convertUtcDate(newDate(PostingDate))}`;
            }
            dispatch({ type: REQUEST_CREATING_RECEIVE });
            axios.get(url,
              {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
            )
            .then(res => {
              dispatch(createReceiveSuccess(res));
              browserHistory.push('/inventories/receive/');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(createReceiveFailure(err));
              }
            });
          }
        }
    }
}

// export function requestCreatingReceive() {
//     return {
//         type: REQUEST_CREATING_RECEIVE
//     }
// }

export function createReceiveSuccess(response) {
    return {
        type: CREATE_RECEIVE_SUCCESS,
        payload: response,
    }
}

export function createReceiveFailure(error) {
    return {
        type: CREATE_RECEIVE_FAILURE,
        payload: error
    }
}

export function resetCreateReceive() {
  return {
    type: RESET_CREATE_RECEIVE,
  };
}

export function editReceive({
    Receive_id,
    ReceiveNum,
    RefNum,
    Name,
    Description,
    CreditStatus,
    IsActive,
    Purchaser_User_id,
    PaymentTerm_id,
    ShippingContact,
    ShippingAddress,
    MailingAddress,
    MailingContact,
    BillingAddress,
    BillingContact,
    Purchase_Order_Line,
}) {
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_RECEIVE });
        axios.put((RECEIVE_URL + 'history/' + Receive_id),
            {
                ReceiveNum,
                RefNum,
                Name,
                Description,
                CreditStatus,
                IsActive,
                Purchaser_User_id,
                PaymentTerm_id: PaymentTerm_id.value,
                ShippingContact,
                ShippingAddress,
                MailingAddress,
                MailingContact,
                BillingAddress,
                BillingContact,
                Purchase_Order_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editReceiveSuccess());
              browserHistory.push('/receives'); // If editd succesfully, refresh the paymentTerm page.
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(editReceiveFailure(err));
              }
            });
    }
}

// export function requestCreatingReceive() {
//     return {
//         type: REQUEST_EDITING_RECEIVE
//     }
// }

export function editReceiveSuccess() {
    return {
        type: EDIT_RECEIVE_SUCCESS
    }
}

export function editReceiveFailure(error) {
    return {
        type: EDIT_RECEIVE_FAILURE,
        payload: error
    }
}

// Fetch the detail page.

export function fetchReceiveDetail(PONum) {
    return dispatch => {
        dispatch(requestReceiveDetail());
        return axios.get(RECEIVE_URL + PONum,
        // return axios.get(RECEIVE_URL + 'history/' + 'P1609220000',
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              if(isOLG) {
                let copyResponse = {...response}
                copyResponse = locationConvertToLowercase(copyResponse);
                dispatch(fetchReceiveDetailSuccess(copyResponse));
              } else {
                dispatch(fetchReceiveDetailSuccess(response));
              }
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchReceiveDetailFailure(err));
              }
            });
    }
}

export function requestReceiveDetail() {
    return {
        type: REQUEST_RECEIVE_DETAIL,
    };
}

export function fetchReceiveDetailSuccess(receiveDetail) {
    return {
        type: FETCH_RECEIVE_DETAIL_SUCCESS,
        payload: receiveDetail
    };
}

export function fetchReceiveDetailFailure(error) {
    return {
        type: FETCH_RECEIVE_DETAIL_FAILURE,
        payload: error
    };
}


export function convertPOToReceive(PO_id) {
    return dispatch => {
        dispatch(requestReceiveDetail());
        return axios.get(RECEIVE_URL + PO_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchReceiveDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchReceiveDetailFailure(err));
              }
            });
    }
}

export function completePurchaseOrder(PONum) { //force to complete
    return dispatch => {
      dispatch({type: COMPLETE_PURCHASE_ORDER}); //add this type later...
      return axios.get(PURCHASE_ORDER_COMPLETE_URL + PONum,
        {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
      .then(response => {
        dispatch(completePurchaseOrderSuccess());
        browserHistory.push('/inventories/receive/');
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(completePurchaseOrderFailure(err));
        }
      });
    }
}

export function completePurchaseOrderSuccess() {
  return {
    type: COMPLETE_PURCHASE_ORDER_SUCCESS
  };
}

export function completePurchaseOrderFailure(error) {
  return {
    type: COMPLETE_PURCHASE_ORDER_FAILURE,
    payload: error
  };
}

export function fetchReceiveHistory(status) {
  if(status == "Arrived") {
    return dispatch => {
      dispatch({type: FETCH_RECEIVE_HISTORY}); //add this type later...
      return axios.get(RECEIVE_URL + 'history/?ArrivalStatus=Arrived',
        {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
      .then(response => {
        dispatch(fetchReceiveHistorySuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchReceiveHistoryFailure(err));
        }
      });
    }
  }
  return dispatch => {
    dispatch({type: FETCH_RECEIVE_HISTORY}); //add this type later...
    return axios.get(RECEIVE_URL + 'history/',
      {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(fetchReceiveHistorySuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchReceiveHistoryFailure(err));
      }
    });
  }
}

export function fetchReceiveHistoryByDate(SalesOrder_gte, SalesOrder_lte, days, isReport, Type, page, limit, PaymentStatus, otherParams = {}) {
  const dates = toFromDates(days, SalesOrder_gte, SalesOrder_lte);
  let report = isReport;
  if (isReport) {
    report = '&Report=true';
  } else {
    report = '&Report=false';
  }

  return (dispatch, getState) => {
    const state = getState();
    const warehouse = state.header.selectedWarehouse;
    const company = state.header.selectedCompany;
    if (!warehouse) return;
    if (!warehouse.value) return;
    dispatch({ type: FETCH_RECEIVE_HISTORY }); // add this type later...
    let url = `${WAREHOUSES_URL}search/?PostingDate__gte=${dates.fromDate}&PostingDate__lte=${dates.toDate}${report}&warehouse_id=${warehouse.value}`;
    if(isGGI || isOCM || isLAP || isAPD) {
      url += `&company_id=${company.value}`;
    }
    const typeParams = {};
    if (isOCM) {
      typeParams.IsTransfer = false;
      typeParams.IsRelocation = false;
      if (Type) {
        typeParams[Type] = true;
      }
    }

    if (isOCM || isSH || isAP) {
      if (page !== null && page !== undefined) {
        otherParams.page = page + 1;
      }
      if (limit !== null && limit !== undefined) {
        otherParams.limit = limit
      }
    }


    if (PaymentStatus) {
      url += `&PaymentStatus=${PaymentStatus}`
    }

    return axios.get(
      url,
      {
        params: { ...typeParams, ...otherParams },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchReceiveHistorySuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchReceiveHistoryFailure(err));
        }
      });
  };
}

export function fetchReceiveHistorySuccess(receiveHistory) {
    return {
        type: FETCH_RECEIVE_HISTORY_SUCCESS,
        payload: receiveHistory
    };
}

export function fetchReceiveHistoryFailure(error) {
    return {
        type: FETCH_RECEIVE_HISTORY_FAILURE,
        payload: error
    };
}

export function selectReceiveHistory(receiveHisoty) {
    return {
        type: SELECT_RECEIVE_HISTORY,
        payload: receiveHisoty
    };
}

export function resetCurrentReceiveHistory() {
    return {
        type: RESET_CURRENT_RECEIVE_HISTORY
    }
}

export function fetchReceiveHistoryDetail(WarehouseReceive_id) {
    return dispatch => {
          dispatch({ type: FETCH_RECEIVE_HISTORY_DETAIL });
        return axios.get(RECEIVE_URL + 'line/inbound/' + WarehouseReceive_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchReceiveHistoryDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchReceiveHistoryDetailFailure(err));
              }
            });
    }
}

export function fetchReceiveHistoryDetailSuccess(receiveHistoryDetail) {
    return {
        type: FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS,
        payload: receiveHistoryDetail
    };
}

export function fetchReceiveHistoryDetailFailure(error) {
    return {
        type: FETCH_RECEIVE_HISTORY_DETAIL_FAILURE,
        payload: error
    };
}

export function fetchAllReceiveHistoryDetail() {
    return dispatch => {
          dispatch({ type: FETCH_RECEIVE_HISTORY_DETAIL });
        return axios.get(RECEIVE_URL + 'line/inbound/',
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchAllReceiveHistoryDetailSuccess(response.data));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchAllReceiveHistoryDetailFailure(err));
              }
            });
    }
}

export function fetchAllReceiveHistoryDetailSuccess(receiveHistoryDetail) {
    return {
        type: FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS,
        payload: receiveHistoryDetail
    };
}

export function fetchAllReceiveHistoryDetailFailure(error) {
    return {
        type: FETCH_RECEIVE_HISTORY_DETAIL_FAILURE,
        payload: error
    };
}

export function fetchReceiveHistoryDetailRecord(WarehouseReceive_id, Warehouse_ReceiveCompleted_id) {
    return dispatch => {
          dispatch({ type: FETCH_RECEIVE_HISTORY_DETAIL_RECORD });
          // if(Warehouse_ReceiveCompleted_id) {
          //   return axios.get(RECEIVE_URL + 'complete/' + Warehouse_ReceiveCompleted_id,
          //       {
          //           headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          //       })
          //       .then(response => {
          //           dispatch(fetchReceiveHistoryDetailRecordSuccess(response));
          //       })
          //       .catch(response => {
          //           dispatch(fetchReceiveHistoryDetailRecordFailure(response));
          //       })
          // }
          // else {
            return axios.get(RECEIVE_URL + 'history/' + WarehouseReceive_id,
                {
                    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                })
                .then(response => {
                  dispatch(fetchReceiveHistoryDetailRecordSuccess(response.data));
                }, err => {
                  if (err.status === 500 || err.status === 404) {
                    err.data = DEFAULT_ERROR;
                  }
                  if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                    document.getElementById('tokenInvalid').style.display = 'flex'
                  } else {
                    dispatch(fetchReceiveHistoryDetailRecordFailure(err));
                  }
                });
          // }
    }
}

export function fetchReceiveHistoryDetailRecordSuccess(receiveHistoryDetail) {
  receiveHistoryDetail.Warehouse_Receive_Line.forEach((line, index) => {
    let expire_datetime = '';
    if (line.expire_datetime) {
      expire_datetime = moment(line.expire_datetime).format('MM-DD-YYYY');
    }
    receiveHistoryDetail.Warehouse_Receive_Line[index].expire_datetime = expire_datetime;
    if (line.package_date) {
      receiveHistoryDetail.Warehouse_Receive_Line[index].package_date = moment(line.package_date).format('MM-DD-YYYY');
    }
  });

  return {
    type: FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS,
    payload: receiveHistoryDetail
  };
}

export function fetchReceiveHistoryDetailRecordFailure(error) {
    return {
        type: FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE,
        payload: error
    };
}

/* Edid receiving and edit purchase payment are sharing this action */
export function editReceiveHistory(
  { WarehouseReceiveCompleted_id,
    WarehouseReceive_id,
    PaymentStatus,
    PostingDate,
    InvoiceDate,
    HandlingCost,
    Vendor_id,
    MiscCost,
    ShippingCost,
    PriceAdjustment,
    InvoiceFinalPrice,
    InvoiceNum,
    PackingNum,
    container_num,
    Note,
    LocalShipCost = 0,
    StorageCost = 0,
    CustomCost = 0,
    OtherCost = 0,
    cso_num = '',
    OverseaShipCost = 0,
    },
    Warehouse_Receive_Line, isPayment, TotalPrice, FinalPrice,
    // SyncAp
    ) {
    //let FinalPrice = (parseFloat(TotalPrice) || 0) + (parseFloat(HandlingCost) || 0) + (parseFloat(MiscCost) || 0) + (parseFloat(ShippingCost) || 0);
    if (Vendor_id && Vendor_id.value) {
      Vendor_id = Vendor_id.value;
    }

    if(PaymentStatus)
      PaymentStatus = PaymentStatus.value || PaymentStatus;
    if(WarehouseReceiveCompleted_id) {
      let Warehouse_Receive_Line_Completed = Warehouse_Receive_Line;
      Warehouse_Receive_Line_Completed.map(
          product => {
              if(product['subWeights']) {
                product['Weights'] = [];
                product.subWeights.map(w => {
                  product['Weights'].push(parseFloat(w.Weight))
                })
              }
          }
      )
      return dispatch => {
          dispatch({ type: REQUEST_EDITING_RECEIVE_HISTORY });
          axios.put((RECEIVE_URL + 'complete/' + WarehouseReceiveCompleted_id),
              {
                  PaymentStatus,
                  Warehouse_Receive_Line_Completed,
                  HandlingCost,
                  Vendor_id,
                  PostingDate,
                  InvoiceDate,
                  MiscCost,
                  ShippingCost,
                  PriceAdjustment,
                  InvoiceFinalPrice,
                  TotalPrice,
                  FinalPrice,
                  InvoiceNum,
                  PackingNum,
                  container_num,
                  Note,
                  // SyncAp
              },
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(editReceiveHistorySuccess(response));
                // if(isPayment === "isPayment") {
                //   browserHistory.push('/purchasePayment'); // If editd succesfully, refresh the paymentTerm page.
                // }
                // else
                // browserHistory.push('/inventories/receiveHistory'); // If editd succesfully, refresh the paymentTerm page.
              }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                  document.getElementById('tokenInvalid').style.display = 'flex'
                } else {
                  dispatch(editReceiveHistoryFailure(err));
                }
              });
      }
    }
    else {
      let data = {
        PaymentStatus,
        PostingDate,
        InvoiceDate,
        Warehouse_Receive_Line,
        HandlingCost,
        Vendor_id,
        MiscCost,
        ShippingCost,
        PriceAdjustment,
        InvoiceFinalPrice,
        TotalPrice,
        FinalPrice,
        InvoiceNum,
        PackingNum,
        container_num,
        Note,
        // SyncAp,
      };
      if(isGGI) {
        data.LocalShipCost = Number(LocalShipCost || 0);
        data.StorageCost =  Number(StorageCost || 0);
        data.CustomCost = Number(CustomCost || 0);
        data.OtherCost =  Number(OtherCost || 0);
        data.OverseaShipCost =  Number(OverseaShipCost || 0);
        data.cso_num = cso_num;
      }
      return dispatch => {
          dispatch({ type: REQUEST_EDITING_RECEIVE_HISTORY });
          Warehouse_Receive_Line.map(
              product => {
                  if(product['subWeights']) {
                    product['Weights'] = [];
                    product.subWeights.map(w => {
                      product['Weights'].push(parseFloat(w.Weight))
                    })
                  }
              }
          )
          axios.put((RECEIVE_URL + 'history/' + WarehouseReceive_id),
              data,
              {
                  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
              }
          )
              .then(response => {
                dispatch(editReceiveHistorySuccess(response));
                // if(isPayment === "isPayment") {
                //   browserHistory.push('/purchasePayment'); // If editd succesfully, refresh the paymentTerm page.
                // }
                // else
                // browserHistory.push('/inventories/receiveHistory');
               }, err => {
                if (err.status === 500 || err.status === 404) {
                  err.data = DEFAULT_ERROR;
                }
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                  document.getElementById('tokenInvalid').style.display = 'flex'
                } else {
                  dispatch(editReceiveHistoryFailure(err));
                }
              });
      }
    }
}

export function editReceiveHistorySuccess(payload) {
  const receiveHistoryDetail = {...payload};
  receiveHistoryDetail.data.Warehouse_Receive_Line.forEach((line, index) => {
    let expire_datetime = '';
    if (line.expire_datetime) {
      expire_datetime = moment(line.expire_datetime).format('MM-DD-YYYY');
    }
    receiveHistoryDetail.data.Warehouse_Receive_Line[index].expire_datetime = expire_datetime;
    if (line.package_date) {
      receiveHistoryDetail.data.Warehouse_Receive_Line[index].package_date = moment(line.package_date).format('MM-DD-YYYY');
    }
  });
    return {
        type: EDIT_RECEIVE_HISTORY_SUCCESS,
        payload: receiveHistoryDetail,
    };
  // return {
  //   type: EDIT_RECEIVE_HISTORY_SUCCESS,
  //   payload,
  // };
}

export function editReceiveHistoryFailure(error) {
    return {
        type: EDIT_RECEIVE_HISTORY_FAILURE,
        payload: error
    };
}

export function resetEditReceiveHistory() {
  return {
    type: RESET_EDIT_RECEIVE_HISTORY,
  };
}

export function voidReceiving(WarehouseReceiveId) {
  return dispatch => {
    dispatch({type: DELETE_RECEIVE});
    return axios.delete(RECEIVE_URL + 'history/' + WarehouseReceiveId,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(response => {
        dispatch(voidReceivingFinished(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(voidReceivingFinished(err));
        }
      });
  }
}

export function voidReceivingFinished(response) {
    return {
        type: DELETE_RECEIVE_FINISHED,
        payload: response,
    };
}

export function resetDeleteStatus() {
  return {
    type: RESET_DELETE_STATUS
  }
}

export function attachFile(WarehouseReceiveNum, files) {
  return dispatch => {
    dispatch({type: ATTACH_FILES});
    var data = new FormData();
    data.append('file', files[0]);
    data.append('WarehouseReceiveNum', WarehouseReceiveNum);

    return axios.post(UPLOAD_URL + 'warehouse/', data,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(response => {
        dispatch(attachFileSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(attachFileFailure(err));
        }
      });
  }
}

export const finalizeReceive = (ids, success, failed) => dispatch => {
  const url = `${WAREHOUSES_URL}receive_update_status/${ids}`;
  axios({
    method: 'PUT',
    url,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
    .then(res => {
      success();
    })
    .catch(err => {
      failed(err);
    })
}

export const syncReceiveHistoryToQuickBook = (receive_ids) => dispatch => {
  const url = `${ROOT_URL}v1/quickbook/sync_purchase_receive_history?receive_ids=${receive_ids}`;
  dispatch({ type: REQUEST_SYNC_QB_PDF });
  axios({
    method: 'POST',
    url,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
    .then(res => {
      dispatch({ type: FETCH_SYNC_QB_PDF_SUCCESS });
      alert('Success!');
    })
    .catch(err => {
      let message = err.data || err;
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        alert(JSON.stringify(message));
      }
      dispatch({ type: FETCH_SYNC_QB_PDF_FAILURE });
    })
}

export function attachFileSuccess() {
    return {
        type: ATTACH_FILES_SUCCESS,
    };
}

export function attachFileFailure(error) {
    return {
        type: ATTACH_FILES_FAILURE,
        payload: error
    };
}

export function fetchAttachedFile(WarehouseReceiveNum, Name) {
  return dispatch => {
    dispatch({type: FETCH_ATTACHED_FILES});
    return axios.post(UPLOAD_URL + 'download/warehouse/',
    {
      WarehouseReceiveNum,
      Name
    },
    {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    })
    .then(response => {
      dispatch(fetchAttachedFileSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchAttachedFileFailure(err));
      }
    });
  }
}

export function fetchAttachedFileSuccess(files) {
  return {
    type: FETCH_ATTACHED_FILES_SUCCESS,
    payload: files
  }
}

export function fetchAttachedFileFailure(error) {
  return {
    type: FETCH_ATTACHED_FILES_FAILURE,
    payload: error
  }
}

export function deleteAttachedFile(WarehouseReceiveNum, Name) {
  return dispatch => {
    dispatch({type: DELETE_ATTACHED_FILES});
    return axios.post(UPLOAD_URL + 'delete/warehouse/',
    {
      WarehouseReceiveNum,
      Name
    },
    {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    })
    .then(response => {
      dispatch(deleteAttachedFileSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(deleteAttachedFileFailure(err));
      }
    });
  }
}

export function deleteAttachedFileSuccess(files) {
  return {
    type: DELETE_ATTACHED_FILES_SUCCESS,
    payload: files
  }
}

export function deleteAttachedFileFailure(error) {
  return {
    type: DELETE_ATTACHED_FILES_FAILURE,
    payload: error
  }
}

export function resetAttachedFile() {
  return {
    type: RESET_ATTACHED_FILES
  }
}

export function setPostingDate(date, Form) {
  return dispatch => {
    dispatch(change(Form, 'PostingDate', date));
  }
}

export function setSelectedRows(rows) {
  return {
    type: SET_RECEIVE_SELECTED_ROWS,
    payload: rows,
  }
}

export function setPaginationFilters(data) {
  return {
    type: SET_RECEIVE_PAGINATION_FILTER,
    currentPage: data.currentPage,
  }
}
export function setScrollTopPositionIndex(index) {
  return {
    type: SET_RECEIVE_SCROLL_TOP_POSITION_INDEX,
    payload: index,
  }
}

const locationConvertToLowercase = (response) => {
  if(response && response.data && response.data.Purchase_Order_Line) {
    let purLines = [...response.data.Purchase_Order_Line];
    purLines.map(r=>{
      if(r.Location) {
        r.location = r.Location;
      }
    })
    let data = {...response.data, Purchase_Order_Line: purLines};
    return {...response, ...data}
  } else {
    return response;
  }
}

export function fetchLogicalLocation(companyId, warehouseId) {
  return new Promise((resolve, reject) => {
    axios.get(LOGICAL_LOCATION_URL,
      {
        params: {company_id: companyId, warehouse_id: warehouseId},
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(response => {
        if (response.status !== 200) {
          alert(response.error)
          reject()
        }
        resolve(response.data)
      })
  })
}



// WEBPACK FOOTER //
// ./master/jsx/actions/receive_actions.js